import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { ReactComponent as WhatsAppIcon } from '../../images/whatsapp-white.svg'; // Importa el SVG
import './style.css';

const Scrollbar = () => {
    // Número de teléfono y mensaje predeterminado
    const phoneNumber = '573336463507'; // Reemplaza con tu número de WhatsApp
    const defaultMessage = 'Hola, estoy interesado en tus servicios.'; // Mensaje predeterminado

    // URL de WhatsApp
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

    return (
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    {/* Botón de scroll hacia arriba */}
                    <li>
                        <AnchorLink href='#scrool'>
                            <i className="ti-arrow-up"></i>
                        </AnchorLink>
                    </li>

                    {/* Botón de WhatsApp con SVG importado */}
                    <li>
                        <a 
                            href={whatsappUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="whatsapp-button mt-3"
                        >
                            {/* Usa el SVG importado */}
                            <WhatsAppIcon width={30} height={30} />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Scrollbar;